module.exports = __webpack_public_path__ + "img/popup-game-sucai.8931c566.png";